import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { CareerPost, CareerSearchParam } from "../type";

interface CareerPostsState {
	list: Array<CareerPost>;
	detail: CareerPost;
  total: number;
}

export const careerPostDefault: CareerPost = {
	categories: [],
	status: "disabled",
	vacancy: 0,
	experience: "",
	updatedBy: 0,
	deadLine: "",
	workingDays: {
		from: "",
		to: "",
	},
	workingHours: {
		from: "",
		to: "",
	},
	__v: 0,
	name: {
		en: "",
		km: "",
		zh: "",
	},
	description: {
		en: "",
		km: "",
		zh: "",
	},
	location: "",
	jobType: "",
};

const initialState: CareerPostsState = {
	list: [],
	detail: careerPostDefault,
  total: 0,
};

export const careerPostSlice = createSlice({
	name: "careerPost",
	initialState,
	reducers: {
		setListCareerPosts: (state, action) => {
			state.list = action.payload.data;
			state.total = action.payload.total;
		},
	},
});

export const selectListCareerPosts = (state: RootState) =>
	state.careerPost.list;
export const selectCareerPostsTotal = (state: RootState) =>
	state.careerPost.total;

export const { setListCareerPosts } = careerPostSlice.actions;

export interface GetListCareerPostAsyncPayload {
	query: CareerSearchParam;
	callback?: () => void;
}

export const getListCareerPostsAsync = createAction(
	"careerPost/getListCareerPosts",
	(payload: GetListCareerPostAsyncPayload) => ({
		payload: payload || {},
	}),
);

export default careerPostSlice.reducer;
